import { ImageTextProps } from './types';
import { ImageAndText } from './variants/ImageAndText';
import { VideoAndText } from './variants/VideoAndText';

export const imageTextVariantsMap: Record<
  ImageTextProps['variant'],
  React.FC<any>
> = {
  video: VideoAndText,
  image: ImageAndText,
};
